/** Map sidebar paths to required module:action permission. */
export const NAV_PERMISSIONS: Record<string, { module: string; action: string }> = {
  '/leads': { module: 'leads', action: 'view' },
  '/crm/customers': { module: 'crm', action: 'view' },
  '/crm/opportunities': { module: 'crm', action: 'view' },
  '/sales/orders': { module: 'sales', action: 'view' },
  '/sales/invoices': { module: 'sales', action: 'view' },
  '/sales/payments': { module: 'sales', action: 'view_payments' },
  '/supply-chain': { module: 'procurement', action: 'view' },
  '/supply-chain/grn': { module: 'procurement', action: 'receive_goods' },
  '/supply-chain/logistics': { module: 'logistics', action: 'view' },
  '/procurement/orders': { module: 'procurement', action: 'view' },
  '/inventory/products': { module: 'inventory', action: 'view' },
  '/inventory/manage': { module: 'inventory', action: 'view' },
  '/inventory/stock': { module: 'inventory', action: 'view' },
  '/inventory/warehouses': { module: 'inventory', action: 'manage_warehouse' },
  '/resource': { module: 'projects', action: 'view' },
  '/dealer': { module: 'dealer', action: 'view' },
  '/manufacturing/boms': { module: 'manufacturing', action: 'view' },
  '/manufacturing/workorders': { module: 'manufacturing', action: 'view' },
  '/quality/checks': { module: 'quality', action: 'view' },
  '/finance/accounts': { module: 'finance', action: 'view_accounts' },
  '/finance/journals': { module: 'finance', action: 'view_journals' },
  '/finance/expenses': { module: 'finance', action: 'view_expenses' },
  '/tax': { module: 'finance', action: 'view_accounts' },
  '/hr/employees': { module: 'hr', action: 'view_employees' },
  '/hr/resource-planning': { module: 'hr', action: 'view_employees' },
  '/hr/attendance': { module: 'hr', action: 'view_attendance' },
  '/hr/leaves': { module: 'hr', action: 'view_leaves' },
  '/hr/leave-module': { module: 'hr', action: 'view_leaves' },
  '/hr/payroll': { module: 'hr', action: 'run_payroll' },
  '/hr/payroll-global': { module: 'hr', action: 'run_payroll' },
  '/projects': { module: 'projects', action: 'view' },
  '/projects/tasks': { module: 'projects', action: 'manage_tasks' },
  '/projects/timesheets': { module: 'projects', action: 'view' },
  '/helpdesk/tickets': { module: 'helpdesk', action: 'view' },
  '/helpdesk/knowledge': { module: 'helpdesk', action: 'manage_kb' },
  '/assets': { module: 'assets', action: 'view' },
  '/documents': { module: 'documents', action: 'view_internal' },
  '/reports': { module: 'reports', action: 'view_sales' },
  '/approvals': { module: 'approvals', action: 'view' },
  '/admin/clients': { module: 'admin', action: 'view_users' },
  '/admin/platform': { module: 'admin', action: 'view_users' },
  '/admin/users': { module: 'admin', action: 'view_users' },
  '/admin/roles': { module: 'admin', action: 'manage_roles' },
  '/admin/company': { module: 'admin', action: 'system_settings' },
  '/admin/settings': { module: 'admin', action: 'system_settings' },
  '/my-space': { module: 'dashboard', action: 'view' },
};

/** Resolve permission for a nav path (strips query string). */
export function navPermission(path: string): { module: string; action: string } | null {
  const base = path.split('?')[0];
  return NAV_PERMISSIONS[base] || null;
}
